import { useUpdateEffect } from 'react-use';

import { useFormController } from '@dreryk/react-common';
import { StyledMargin, Toggle } from '@dreryk/react-components';

import { nfzSettingsTranslationKeys } from '../../../translations';

import { useCurrentHealthcareProviderEwusAutomaticStatusCheckSetCommand } from './NfzSettingsSaveAction.hooks';

type EwusAutomaticStatusCheckToggleProps = {
   readonly initialValue: boolean;
   readonly disabled: boolean;
};

export const EwusAutomaticStatusCheckToggle = (props: EwusAutomaticStatusCheckToggleProps): JSX.Element => {
   const { register, watch } = useFormController<{ value: boolean }>({ value: props.initialValue });

   const {
      executeAsync: setAutomaticStatusCheck,
      loading,
   } = useCurrentHealthcareProviderEwusAutomaticStatusCheckSetCommand();

   const currentValue = watch('value');

   useUpdateEffect(() => {
      setAutomaticStatusCheck({ enabled: currentValue });
   }, [currentValue]);

   return (
      <StyledMargin left={32}>
         <Toggle
            controller={register('value')}
            label={nfzSettingsTranslationKeys.automaticEwusStatusVerification}
            testId={'ewusAutomaticStatusCheck'}
            disabled={props.disabled || loading}
            horizontal
         />
      </StyledMargin>
   );
};
